function getRandomId(): string {
    return (
        window.crypto.getRandomValues(new Uint32Array(1))[0].toString(36) +
        window.crypto.getRandomValues(new Uint32Array(1))[0].toString(36) +
        window.crypto.getRandomValues(new Uint32Array(1))[0].toString(36) +
        window.crypto.getRandomValues(new Uint32Array(1))[0].toString(36).substring(2, 4)
    );
}

export const randomId = getRandomId();